export function AchievementBadge({
  color,
  icon,
  size = 52,
  state = 'unlocked',
}: {
  color: string
  icon: React.ReactNode
  size?: number
  state?: 'unlocked' | 'progress' | 'locked'
}) {
  const id = `ach-${color.replace('#', '')}-${state}`
  const opacity = state === 'locked' ? 0.4 : 1
  const filter = state === 'locked' ? 'grayscale(100%)' : 'none'
  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size, filter, opacity }}
    >
      <svg viewBox="0 0 80 80" width={size} height={size}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={color} />
            <stop offset="100%" stopColor={color} stopOpacity="0.55" />
          </linearGradient>
        </defs>
        <polygon
          points="40,6 70,22 70,58 40,74 10,58 10,22"
          fill={`url(#${id})`}
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-background"
        />
        <polygon
          points="40,14 62,26 62,54 40,66 18,54 18,26"
          fill="currentColor"
          opacity="0.25"
          className="text-foreground"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-white">{icon}</div>
    </div>
  )
}
